<template>
  <base-list-item id="spin-dj-media-player" v-if="track">
    <Track :track="track" :current-time="currentTime" :duration="duration" />
    <round-button-with-icon
      v-if="player"
      :icon="icon"
      class="spin-dj-media-player-icon"
      @click="playPause"
    />
    <round-button-with-icon icon="x" @click="unloadTrack" />
    <round-button-with-icon
      v-if="!player"
      icon="spinner"
      class="spin-dj-media-player-icon"
    />
    <audio
      id="spin-dj-media-player-audio-element"
      @ended="unloadTrack"
      @timeupdate="updateCurrentTime"
    />
  </base-list-item>
</template>
<script>
import BaseListItem from "../../Components/UI/ListItems/BaseListItem.vue";
import RoundButtonWithIcon from "../UI/RoundButtonWithIcon.vue";
import Track from "../Spotify/Track.vue";
export default {
  data() {
    return {
      player: undefined,
      paused: false,
      unobstructed: false,
      currentTime: 0,
      duration: 0,
    };
  },
  computed: {
    track() {
      return this.$store.state.audioTrack;
    },
    icon() {
      console.log(this.paused);

      if (this.paused) {
        console.log("paused");
        return "play";
      } else {
        console.log("playing");
        return "pause";
      }
    },
  },
  methods: {
    unloadTrack() {
      this.player.pause();
      this.$store.commit("unloadTrack");
    },
    playPause() {
      if (this.paused) {
        this.player.play();
        this.paused = false;
      } else {
        this.player.pause();
        this.paused = true;
      }
    },
    processTime(time) {
      let m = Math.floor(time / 60);
      let s = Math.ceil(time % 60).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
      });
      return `${m}:${s}`;
    },
    updateCurrentTime() {
      this.currentTime = this.processTime(this.player.currentTime);
      this.duration = this.processTime(this.player.duration);
    },
  },
  created() {
    setTimeout(() => {
      this.player = document.getElementById(
        "spin-dj-media-player-audio-element"
      );
      this.player.src = this.track.preview_url;
      this.player.load();
      this.player.play();
      this.paused = false;
    }, 500);
  },
  watch: {
    track(oldValue, newValue) {
      if (oldValue !== newValue) {
        this.player.pause();
        this.player.src = this.track.preview_url;
        this.player.load();
        this.player.play();
        this.paused = false;
      }
    },
  },
  components: {
    BaseListItem,
    Track,
    RoundButtonWithIcon,
  },
  props: [],
};
</script>
<style scoped>
@media screen {
  #spin-dj-media-player {
    position: fixed;
    z-index: 3;
    bottom: 10px;
    max-width: 100%;
    width: 250px;
    left: 50%;
    transform: translateX(-50%);
    filter: drop-shadow(0px 0px 3px var(--shadow));
    display: flex;
    align-items: center;
  }

  .spin-dj-media-player-icon {
    height: 40px;
    width: 40px;
  }
  @media (min-width: 550px) {
    #spin-dj-media-player {
      right: 10px;
      top: 10px;
      left: unset;
      bottom: unset;
      transform: unset;
    }
  }
}
</style>
